<template>
  <div class="family-group-list-page">
    <h1>Groups</h1>
    <FamilyGroupList />
  </div>
</template>

<style lang="scss" scoped>
</style>

<script setup lang="ts">
import FamilyGroupList from './FamilyGroupList.vue'
import { usePageTitle } from '@/util/AppUtil'

usePageTitle("Groups")
</script>
